import {
  GET_ADOPTIONANALYSIS_DETAILS,
  GET_PAYOUT_DETAILS,
  GET_USSAGECOVERAGE_DETAILS,
  GET_USSAGECOVERAGE_FILTERS,
  GET_WIDGET_DETAILS,
  GET_USSAGECOVERAGE_DCPIC_IMAGES,
  GET_ADDITIONAL_FILTER
} from "../../Utils/types";

const initialState = {
  getPayoutDetails: [],
  getUsageCoverageDetails: [],
  getWidgetDetails: [],
  getAdoptionAnalysisDetails: [],
  getUsageCoverageFilters: [],
  getUsageCoverageDcPicImages: [],
  getAdditionalFilter:{}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYOUT_DETAILS:
      return {
        ...state,
        getPayoutDetails: action.payload,
      };
    case GET_USSAGECOVERAGE_DETAILS:
      return {
        ...state,
        getUsageCoverageDetails: action.payload,
      };
    case GET_USSAGECOVERAGE_DCPIC_IMAGES:
      return {
        ...state,
        getUsageCoverageDcPicImages: action.payload,
      };
    case GET_USSAGECOVERAGE_FILTERS:
      return {
        ...state,
        getUsageCoverageFilters: action.payload,
      };
    case GET_WIDGET_DETAILS:
      return {
        ...state,
        getWidgetDetails: action.payload,
      };
    case GET_ADOPTIONANALYSIS_DETAILS:
      return {
        ...state,
        getAdoptionAnalysisDetails: action.payload,
      };
    case GET_ADDITIONAL_FILTER:
      return {
        ...state,
        getAdditionalFilter: action.payload,
      };
    default:
      return state;
  }
};
